import { render, staticRenderFns } from "./PurgeCacheForm.vue?vue&type=template&id=7df602f0&scoped=true"
import script from "./PurgeCacheForm.vue?vue&type=script&lang=js"
export * from "./PurgeCacheForm.vue?vue&type=script&lang=js"
import style0 from "./PurgeCacheForm.vue?vue&type=style&index=0&id=7df602f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df602f0",
  null
  
)

export default component.exports